/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
import useSWR from "swr";
import {
  getMonitoringIncidents,
  refreshMonitoringIncidents,
  MonitoringResponse,
} from "./data/monitoring-service";

export const useMonitoringData = () => {
  const { data, error, isLoading, mutate } = useSWR<MonitoringResponse>(
    "/monitoring/rss/incidents",
    getMonitoringIncidents,
    {
      refreshInterval: 480000, // Auto-refresh every 8 minutes
      revalidateOnFocus: true,
    },
  );

  const refresh = async (): Promise<void> => {
    try {
      const refreshedData = await refreshMonitoringIncidents();
      // Update SWR cache with the fresh data from the POST endpoint
      mutate(refreshedData);
    } catch (err) {
      console.log("Error refreshing monitoring incidents:", err);
    }
  };

  return {
    data,
    isLoading,
    error,
    refresh,
  };
};
